import { World } from "../threeMain";

export type System = (world: World) => any;
type SystemType = "prerender" | "render" | "postrender"

export interface MainSystem {
  systems: any[],
  _paused: boolean,
  _maxFps: number,
  _fpsCount: number,
  _lastSecond: number,
  _minDelta: number,
  fps: number,
  play: (world: World) => void,
  pause: (world: World) => void,
  addSystem: (system: any, systemType: SystemType) => any,
  setMaxFps: (fps: number) => any,
  systemOrder: {
    prerender: System[],
    renderSystem: System | null,
    postrender: System[],
  }
}

export function createMainSystem(world: World, {maxFps= 60} = {}){
  const mainSystem : MainSystem = {
    systems: [],
    _maxFps: maxFps,
    _fpsCount: 0,
    _lastSecond: 0,
    _minDelta: maxFps ? Math.floor(1000/maxFps) : 0,
    _paused: true,
    fps: 0,
    systemOrder: {
      prerender: [],
      renderSystem: null,
      postrender: [],
    },
    setMaxFps: (fps: number) => {
      mainSystem._maxFps = fps;
      if(!fps) mainSystem._minDelta = 0;
      else mainSystem._minDelta = Math.floor(1000/fps);
    },
    play: (world: World) => {
      mainSystem._paused = false; 
      const render = () => {
        if(mainSystem._paused) return;
        //Enable Fix fps limiter
        requestAnimationFrame(render)
        const { time } = world
        const now = performance.now()
        const delta = now - time.then;

        if(delta <= mainSystem._minDelta) return;
        time.delta = delta
        time.elapsed += delta
        time.then = now

        const { prerender, renderSystem, postrender} = mainSystem.systemOrder;
        if(!renderSystem) return;
        //Calculate fps
        const lastSecondDelta = now - mainSystem._lastSecond;
        if(lastSecondDelta > 1000){
          mainSystem._lastSecond = now;
          mainSystem.fps = mainSystem._fpsCount;
          mainSystem._fpsCount = 0;
        }
        mainSystem._fpsCount++; 
        prerender.forEach(( system: System ) => (system(world)))
        renderSystem(world);
        postrender.forEach(( system: System ) => (system(world)))
      }
      render();
    },
    pause: (world) => { mainSystem._paused = true },
    addSystem: (system: System, type: SystemType) => {
      if(type == "prerender") mainSystem.systemOrder.prerender.push(system)
      else if(type == "postrender") mainSystem.systemOrder.postrender.push(system)
      else if(type == "render") mainSystem.systemOrder.renderSystem = system
      else console.error("[MainSystem] Systemtype now known")
    }

  }

  return mainSystem
}